const screenSizeArray = ['mobile', 'sm', 'md', 'lg', 'xl', '2xl']

export default screenSizeArray
